var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveDoctor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.19,
    height: 56.016,
    viewBox: "0 0 55.19 56.016",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RemovePhysician_icon",
    "data-name": "RemovePhysician icon",
    transform: "translate(1.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7184",
    "data-name": "Path 7184",
    d: "M3.451,11.357,0,10.042S.331-.052,5.535,0,11.5,10.042,11.5,10.042L7.988,11.357",
    transform: "matrix(0.998, -0.07, 0.07, 0.998, 5.444, 30.545)",
    fill: "none",
    stroke: "#053f7f",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(5.444)",
    fill: "none",
    stroke: "#053f7f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.699,
    cy: 11.699,
    rx: 11.699,
    ry: 11.699,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.699,
    cy: 11.699,
    rx: 10.699,
    ry: 10.699,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M1471.075,291.371s-10.311,8.54-6.906,20.834c1.788,6.454,32.2,6.39,33.438,0a22.636,22.636,0,0,0-6.861-20.834",
    transform: "translate(-1463.48 -270.354)",
    fill: "none",
    stroke: "#053f7f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_154",
    "data-name": "Ellipse 154",
    transform: "translate(22.556 28.032)",
    fill: "#053f7f",
    stroke: "#053f7f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.889,
    cy: 3.889,
    r: 3.889,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.889,
    cy: 3.889,
    r: 3.389,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7188",
    "data-name": "Path 7188",
    d: "M4.6,7.815A11.438,11.438,0,0,1,1.629,5.208C.462,3.652.361-.638.361-.638",
    transform: "translate(6.423 22.201)",
    fill: "none",
    stroke: "#053f7f",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7187",
    "data-name": "Path 7187",
    d: "M0,6.222A6.7,6.7,0,0,0,1.556,3.491,9.37,9.37,0,0,0,1.556,0",
    transform: "translate(26.444 22.556)",
    fill: "none",
    stroke: "#053f7f",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_171",
    "data-name": "Ellipse 171",
    transform: "translate(28.173 30.016)",
    fill: "#fff",
    stroke: "#043e7e",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_63950",
    "data-name": "Line 63950",
    x2: 12.444,
    y2: 12.444,
    transform: "translate(34.951 36.794)",
    fill: "none",
    stroke: "#ff5050",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63951",
    "data-name": "Line 63951",
    x1: 12.444,
    y2: 12.444,
    transform: "translate(34.951 36.794)",
    fill: "none",
    stroke: "#ff5050",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveDoctor);
export default __webpack_public_path__ + "static/media/remove-doctor.438e684a8fad0a897a17582e45746334.svg";
export { ForwardRef as ReactComponent };